// Static reference data for Kushe (countries, currencies, categories, plans)

export const COUNTRIES = [
  { code: 'NG', name: 'Nigeria', flag: '🇳🇬', currency: 'NGN' },
  { code: 'GH', name: 'Ghana', flag: '🇬🇭', currency: 'GHS' },
  { code: 'SN', name: 'Sénégal', flag: '🇸🇳', currency: 'XOF' },
  { code: 'CI', name: "Côte d'Ivoire", flag: '🇨🇮', currency: 'XOF' },
  { code: 'ML', name: 'Mali', flag: '🇲🇱', currency: 'XOF' },
  { code: 'BF', name: 'Burkina Faso', flag: '🇧🇫', currency: 'XOF' },
  { code: 'BJ', name: 'Bénin', flag: '🇧🇯', currency: 'XOF' },
  { code: 'TG', name: 'Togo', flag: '🇹🇬', currency: 'XOF' },
  { code: 'NE', name: 'Niger', flag: '🇳🇪', currency: 'XOF' },
  { code: 'GN', name: 'Guinée', flag: '🇬🇳', currency: 'GNF' },
  { code: 'SL', name: 'Sierra Leone', flag: '🇸🇱', currency: 'SLL' },
  { code: 'LR', name: 'Libéria', flag: '🇱🇷', currency: 'LRD' },
  { code: 'GM', name: 'Gambie', flag: '🇬🇲', currency: 'GMD' },
  { code: 'GW', name: 'Guinée-Bissau', flag: '🇬🇼', currency: 'XOF' },
  { code: 'CV', name: 'Cap-Vert', flag: '🇨🇻', currency: 'CVE' },
  { code: 'FR', name: 'France (Diaspora)', flag: '🇫🇷', currency: 'EUR' },
  { code: 'GB', name: 'UK (Diaspora)', flag: '🇬🇧', currency: 'GBP' },
  { code: 'US', name: 'USA (Diaspora)', flag: '🇺🇸', currency: 'USD' },
];

export const CURRENCIES = {
  XOF: { symbol: 'CFA', rate: 1 },
  NGN: { symbol: '₦', rate: 2.7 },
  GHS: { symbol: 'GH₵', rate: 0.025 },
  EUR: { symbol: '€', rate: 0.00152 },
  USD: { symbol: '$', rate: 0.00165 },
  GBP: { symbol: '£', rate: 0.0013 },
  GNF: { symbol: 'FG', rate: 14.2 },
  GMD: { symbol: 'D', rate: 0.11 },
  CVE: { symbol: '$', rate: 0.17 },
  SLL: { symbol: 'Le', rate: 36 },
  LRD: { symbol: 'L$', rate: 0.3 },
};

export const CATEGORIES = [
  { id: 'fashion', name: { fr: 'Mode & Textile', en: 'Fashion & Textile', pt: 'Moda & Têxtil' }, icon: 'Shirt', color: '#E8814A', count: 12847 },
  { id: 'electronics', name: { fr: 'Électronique', en: 'Electronics', pt: 'Eletrônicos' }, icon: 'Smartphone', color: '#0F8B5C', count: 8932 },
  { id: 'vehicles', name: { fr: 'Véhicules', en: 'Vehicles', pt: 'Veículos' }, icon: 'Car', color: '#1F6FB2', count: 5421 },
  { id: 'realestate', name: { fr: 'Immobilier', en: 'Real Estate', pt: 'Imóveis' }, icon: 'Home', color: '#8B5A3C', count: 3215 },
  { id: 'beauty', name: { fr: 'Beauté & Soins', en: 'Beauty & Care', pt: 'Beleza' }, icon: 'Sparkles', color: '#D4357A', count: 4612 },
  { id: 'food', name: { fr: 'Agroalimentaire', en: 'Food & Agriculture', pt: 'Agroalimentar' }, icon: 'Wheat', color: '#F2B441', count: 6789 },
  { id: 'services', name: { fr: 'Services', en: 'Services', pt: 'Serviços' }, icon: 'Briefcase', color: '#5B4FA8', count: 3411 },
  { id: 'home', name: { fr: 'Maison & Déco', en: 'Home & Decor', pt: 'Casa & Decoração' }, icon: 'Lamp', color: '#2A8A8A', count: 4128 },
  { id: 'crafts', name: { fr: 'Artisanat', en: 'Crafts', pt: 'Artesanato' }, icon: 'Palette', color: '#C25C2E', count: 2974 },
  { id: 'jobs', name: { fr: 'Emplois', en: 'Jobs', pt: 'Empregos' }, icon: 'BriefcaseBusiness', color: '#3B6CB0', count: 1856 },
];

export const PRICING_PLANS = [
  {
    id: 'free', name: { fr: 'Gratuit', en: 'Free', pt: 'Grátis' }, price: 0,
    features: { fr: ['3 annonces actives', 'Visibilité standard', 'Messagerie acheteurs', 'Profil de base'], en: ['3 active listings', 'Standard visibility', 'Buyer messaging', 'Basic profile'], pt: ['3 anúncios ativos', 'Visibilidade padrão', 'Mensagens', 'Perfil básico'] },
    cta: { fr: 'Commencer', en: 'Get started', pt: 'Começar' },
  },
  {
    id: 'pro', name: { fr: 'Pro Marchand', en: 'Pro Seller', pt: 'Pro Vendedor' }, price: 4900, popular: true,
    features: { fr: ['Annonces illimitées', '5 boosts inclus / mois', 'Badge vérifié', 'Statistiques avancées', 'Support prioritaire', 'Paiement Mobile Money'], en: ['Unlimited listings', '5 boosts included/month', 'Verified badge', 'Advanced analytics', 'Priority support', 'Mobile Money payouts'], pt: ['Anúncios ilimitados', '5 boosts incluídos/mês', 'Selo verificado', 'Análises avançadas', 'Suporte prioritário', 'Mobile Money'] },
    cta: { fr: 'Devenir Pro', en: 'Go Pro', pt: 'Tornar-se Pro' },
  },
  {
    id: 'business', name: { fr: 'Business Diaspora', en: 'Business Diaspora', pt: 'Business Diáspora' }, price: 14900,
    features: { fr: ['Tout du plan Pro', 'Boutique en ligne dédiée', 'Expédition diaspora intégrée', 'Multi-devises automatique', 'Account manager dédié', 'API & intégrations'], en: ['Everything in Pro', 'Dedicated online store', 'Diaspora shipping integrated', 'Auto multi-currency', 'Dedicated account manager', 'API & integrations'], pt: ['Tudo do Pro', 'Loja dedicada', 'Envio diáspora', 'Multi-moeda', 'Gerente de conta', 'API & integrações'] },
    cta: { fr: 'Contacter ventes', en: 'Contact sales', pt: 'Contactar vendas' },
  },
];

export const PAYMENT_METHODS = [
  { id: 'orange', name: 'Orange Money', color: '#FF6600' },
  { id: 'mtn', name: 'MTN MoMo', color: '#FFCC00' },
  { id: 'wave', name: 'Wave', color: '#1A1F71' },
  { id: 'moov', name: 'Moov Money', color: '#0066CC' },
  { id: 'card', name: 'Visa / Mastercard', color: '#1A1A1A' },
  { id: 'paypal', name: 'PayPal (Diaspora)', color: '#003087' },
];

export const TESTIMONIALS = [
  { id: 't1', name: 'Aminata K.', location: 'Dakar → Paris', avatar: 'AK', rating: 5, text: {
    fr: 'Kushe m\'a permis de vendre mes créations à la diaspora française. +180% de chiffre d\'affaires en 6 mois.',
    en: 'Kushe let me sell my creations to the French diaspora. +180% revenue in 6 months.',
    pt: 'O Kushe permitiu-me vender as minhas criações à diáspora francesa. +180% de receita em 6 meses.' } },
  { id: 't2', name: 'Kwame O.', location: 'Accra', avatar: 'KO', rating: 5, text: {
    fr: 'La plateforme la plus fiable pour acheter en confiance. Vendeurs vérifiés et paiement sécurisé Mobile Money.',
    en: 'The most reliable platform to buy with confidence. Verified sellers and secure Mobile Money payments.',
    pt: 'A plataforma mais fiável para comprar com confiança. Vendedores verificados e pagamento seguro Mobile Money.' } },
  { id: 't3', name: 'Fatou D.', location: 'Bamako → New York', avatar: 'FD', rating: 5, text: {
    fr: 'Je commande du karité bio directement du Mali. Livraison rapide, qualité authentique. Bravo Kushe !',
    en: 'I order organic shea butter straight from Mali. Fast delivery, authentic quality. Well done Kushe!',
    pt: 'Encomendo karité biológico diretamente do Mali. Entrega rápida, qualidade autêntica. Parabéns Kushe!' } },
  { id: 't4', name: 'Ibrahim S.', location: 'Lagos', avatar: 'IS', rating: 5, text: {
    fr: 'En tant que commerçant, le plan Pro a doublé mes ventes. Le boost et les stats sont vraiment efficaces.',
    en: 'As a merchant, the Pro plan doubled my sales. Boosts and analytics really work.',
    pt: 'Como comerciante, o plano Pro duplicou as minhas vendas. O boost e as estatísticas são muito eficazes.' } },
];

export const STATS = [
  { id: 'users', value: '2.4M+', label: { fr: 'Utilisateurs actifs', en: 'Active users', pt: 'Utilizadores ativos' } },
  { id: 'countries', value: '15', label: { fr: 'Pays CEDEAO', en: 'ECOWAS countries', pt: 'Países CEDEAO' } },
  { id: 'listings', value: '850K+', label: { fr: 'Annonces publiées', en: 'Listings posted', pt: 'Anúncios' } },
  { id: 'volume', value: '€4.2M', label: { fr: 'Transactions mensuelles', en: 'Monthly transactions', pt: 'Transações/mês' } },
];

export const formatPrice = (amount, currency = 'XOF', targetCurrency = null, locale = 'fr-FR') => {
  const target = targetCurrency || currency;
  const xofAmount = amount / (CURRENCIES[currency]?.rate || 1);
  const converted = xofAmount * (CURRENCIES[target]?.rate || 1);
  const symbol = CURRENCIES[target]?.symbol || target;
  const rounded = converted >= 1000 ? Math.round(converted).toLocaleString(locale) : converted.toFixed(2);
  return `${rounded} ${symbol}`;
};

export const timeAgo = (iso, lang = 'en') => {
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  const labels = {
    fr: { m: 'min', h: 'h', d: 'j', now: "à l'instant" },
    en: { m: 'min', h: 'h', d: 'd', now: 'just now' },
    pt: { m: 'min', h: 'h', d: 'd', now: 'agora' },
  };
  const l = labels[lang] || labels.en;
  if (diff < 60) return l.now;
  if (diff < 3600) return `${Math.floor(diff / 60)} ${l.m}`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} ${l.h}`;
  return `${Math.floor(diff / 86400)} ${l.d}`;
};
